<template>
  <header toggleable>
    <quit-confirm-modal />
    <settings-sidebar />
    <b-navbar class="navbar-item">
      <b-row class="my-3">
        <b-col cols="12" class="nav-place">
          <b-button @click="$bvModal.show('quit-confirm-modal')" variant="default">
            <img alt="Quit quiz" src="../../../core/Images/icon-close-high-contrast.svg">
          </b-button>
          <b-button variant="default" class="icon-nav" v-b-toggle.settings-sidebar>
            <span></span>
          </b-button>
          <img alt="Quit quiz" src="../Img/ja-logo.svg" class="float-right">
        </b-col>
      </b-row>
      <div ref="navbarProgress" class="navbar-item-center" tabindex="0" :aria-label="getProgressAriaLabel()">
        <div class="page-progress"></div>
        <div class="page-progress-fill" :style="{ width: progressBarPercentage }"></div>
        <div class="page-number">{{ pageNumber }}</div>
      </div>
    </b-navbar>
  </header>
</template>

<script>
import SettingsSidebar from "./SettingsSidebar";
import QuitConfirmModal from "./QuitConfirmModal";
import {UtilsI18n} from '../../../core/Utils'

export default {
  name: "QuestionHeader",
  components: {QuitConfirmModal, SettingsSidebar},
  data() {
    return {
      progressBarPercentage: 0,
      pageNumber: 0
    }
  },
  methods: {
    getProgressAriaLabel() {
      return UtilsI18n.interpolateString(this.$t("quiz_progress_aria_label"), {number: this.$route.params.questionNumber})
    },
    getProgressBarWidth(progressBarWidth = 0) {
      if (progressBarWidth) {
        const pageNumber = this.$route.params.questionNumber
        const totalNumber = 10
        if (!Number.isNaN(pageNumber)) {
          return (((progressBarWidth / totalNumber * pageNumber) / progressBarWidth) * 100).toFixed(3)
        }
      }
      return 10
    }
  },
  watch: {
    '$route.params.questionNumber': {
      handler: function () {
        this.$nextTick(() => {
          if(this.$route.params.questionNumber <= 10) {
            this.pageNumber = `${this.$route.params.questionNumber}/10`
            this.progressBarPercentage = this.getProgressBarWidth(this.$refs.navbarProgress?.clientWidth) + '%'
            this.$refs.navbarProgress.focus()
          }
        })
      },
      deep: true,
      immediate: true
    },
  }
};
</script>

<style lang="stylus" scoped>
@import "~@/core/Styles/mixins.styl"
@import "~@/core/Styles/variables.styl"

.navbar-item
  display inline

.nav-place
  padding-left: 0
  padding-right: 0

.navbar-item-center
  text-align center

  .page-number
    font-family: 'Source Sans Pro', sans-serif
    font-size: 16px
    font-weight: bold;
    color: color-8
    text-align left

  .page-progress
    border: solid 1px #EDEDED
    margin-top: 20px
    border-radius: 25px

  .page-progress-fill
    border: solid 2px color-orange
    background-color color-orange
    border-radius: 25px
    position: relative
    top: -3px

.icon-nav
  float right
  &:hover
    span
      transition(background 0.3s)
      background-image url("../../../core/Images/sidebar_icon_hover.svg")
  span
    display inline-block
    width 20px
    height 20px
    background-image url("../../../core/Images/nav_icon_close.svg")
    background-position center
    background-repeat no-repeat
    background-size contain
    transition(background 0.3s)
</style>


